import {
    ControlInput,
    FormContext,
    FormControl,
    FormValues
} from "../../types";

import Timer from "./timer";
import { iTimer } from "./types";

/**
 * Timer attributes available to GravityForms
 */
const timerAttributes: Array<keyof iTimer> = ["elapsed", "from", "to", "tick"];

/**
 * Safely get field inputs
 * @param field
 * @returns ControlInput[]
 */
const getFieldInputs = (field: FormControl | null): ControlInput[] =>
    (field && field.inputs) || [];

/**
 * Convert a timer to an object GravityForms understands
 * @param timer
 * @param inputs
 * @returns
 */
const timer2Inputs = (timer: iTimer, inputs: ControlInput[]) =>
    timerAttributes.reduce(
        (v, attr, i) =>
            inputs[i] && !inputs[i].isHidden
                ? { ...v, [inputs[i].id]: timer[attr] }
                : v,
        {}
    );

/**
 * PreSubmission adaptor for GravityForms
 * @param values
 * @param context
 * @returns
 */
const preSubmissionAdaptor = (values: FormValues, context: FormContext) => ({
    ...values,
    ...Object.entries(values).reduce((updates, [k, v]) => {
        if (v instanceof Timer) {
            v.stop();
            return {
                ...updates,
                [k]: timer2Inputs(v, getFieldInputs(context.getControl(k)))
            };
        }
        return updates;
    }, {})
});

export { preSubmissionAdaptor };
